/**
 * MyLogin-only bundle: Alpine + MyLogin screens/components.
 */
import Alpine from 'alpinejs';
import registerComponents from './components';
import registerScreens from './screens';

window.Bowser = require('bowser');

window.Alpine = Alpine;
registerComponents(Alpine);
registerScreens(Alpine);
Alpine.start();
